import { Box } from "@mui/material";
import "./commonstyle.css";
const ImageBox = (props) => {
    return (<>
    <Box sx={{ height:'100%'}} >
        <img className={props.myclass} src={props.imageUrl} alt="login Image" />
    </Box>
    </>)
}

export default ImageBox